import React from 'react';

const TimeIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3552_197028)">
        <path
          d="M17.9141 12.082V3.33203C17.9141 2.66536 17.3307 2.08203 16.6641 2.08203H1.66406C0.997396 2.08203 0.414062 2.66536 0.414062 3.33203V16.6654C0.414062 17.332 0.997396 17.9154 1.66406 17.9154H12.0807"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.0026 4.58333C5.23272 4.58333 5.41927 4.39679 5.41927 4.16667C5.41927 3.93655 5.23272 3.75 5.0026 3.75C4.77249 3.75 4.58594 3.93655 4.58594 4.16667C4.58594 4.39679 4.77249 4.58333 5.0026 4.58333Z"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3307 4.58333C13.5608 4.58333 13.7474 4.39679 13.7474 4.16667C13.7474 3.93655 13.5608 3.75 13.3307 3.75C13.1006 3.75 12.9141 3.93655 12.9141 4.16667C12.9141 4.39679 13.1006 4.58333 13.3307 4.58333Z"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.41406 4.16797V0.417969M13.7474 4.16797V0.417969M0.414062 6.2513H17.9141"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4167 19.5833C17.7179 19.5833 19.5833 17.7179 19.5833 15.4167C19.5833 13.1155 17.7179 11.25 15.4167 11.25C13.1155 11.25 11.25 13.1155 11.25 15.4167C11.25 17.7179 13.1155 19.5833 15.4167 19.5833Z"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4141 12.918V15.418L16.6641 16.668"
          stroke="#1B2124"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3552_197028">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimeIcon;
